import {
  faIdCard,
  faBuilding,
  faFire,
  faFileContract,
  faDna,
  faCalendar,
  faUser,
  faUsers,
  faBullhorn,
} from '@fortawesome/free-solid-svg-icons';
import { Signal } from '@angular/core';
import { ProfileTab } from '../shared/components/profile-shell/profile-tab.interface';
import { APP_CONFIG } from 'src/assets/config/app-config';
import { Capabilities } from '../shared/stores/current-user.store';

export interface StudentProfileTabContext {
  capabilities: Signal<Capabilities>;
}

export function getStudentProfileTabs(callbacks: {
  onMatchCompanyActivate: () => void;
  onMatchJobpostingActivate: () => void;
  onDnaActivate: () => void;
}, ctx?: StudentProfileTabContext): ProfileTab[] {
  const canViewFollowUpDays = () =>
    ctx ? ctx.capabilities().canViewFollowUpDays : true;

  return [
    { id: 'cv', label: 'CV', icon: faIdCard, iconClass: 'text-primary' },
    { id: 'oproepen', label: 'My announcements', icon: faBullhorn, iconClass: 'text-purple' },
    { id: 'companies', label: 'Companies', icon: faBuilding, iconClass: 'text-primary', isRouterLink: true, routerLink: '/student/companies' },
    { id: 'matchtest', label: 'Match test', icon: faFire, iconClass: 'text-danger' },
    { id: 'matches-company', label: 'Matches companies', icon: faBuilding, iconClass: 'text-success', indent: true, onActivate: callbacks.onMatchCompanyActivate },
    { id: 'matches-jobposting', label: 'Matches jobs', icon: faFileContract, iconClass: 'text-success', indent: true, onActivate: callbacks.onMatchJobpostingActivate },
    { id: 'dna', label: 'DNA', icon: faDna, iconClass: 'text-warning', visible: () => APP_CONFIG.isDNAEnabled, onActivate: callbacks.onDnaActivate },
    { id: 'experienceday', label: 'Follow-up days', icon: faCalendar, iconClass: 'text-purple', visible: canViewFollowUpDays },
  ];
}

export function getTeacherProfileTabs(): ProfileTab[] {
  return [
    { id: 'profile', label: 'Profile', icon: faUser, iconClass: 'text-primary' },
    { id: 'students', label: 'My students', icon: faUsers, iconClass: 'text-primary' },
  ];
}
